export default __webpack_public_path__ + "static/media/ProfitLoss.13463cd4.png";